import { unwrapResult } from "@reduxjs/toolkit";
import { Device } from "../../../device/deviceSlice";
import { CreateDeviceDialog } from "../../../device/dialogs/DeviceCreateEditDialog";
import { APIError, AppId } from "../../../../app/appTypes";
import { useAppDispatch } from "../../../../app/hooks";
import { showError } from "../../../notifications/notificationsSlice";
import { linkValidationProjectDevice, ValidationProjectDeviceDto } from "../validationProjectSlice";

export interface CreateAndLinkValidationProjectDeviceDialogProps {
	projectId: AppId;
	onSuccess: (device: ValidationProjectDeviceDto) => void;
	onCancel: () => void;
}

export const CreateAndLinkValidationProjectDeviceDialog = ({ projectId, onSuccess, onCancel }: CreateAndLinkValidationProjectDeviceDialogProps) => {
	const dispatch = useAppDispatch();

	const handleDeviceCreated = async (device: Device) => {
		try {
			const result = await dispatch(linkValidationProjectDevice({
				id: projectId,
				payload: {
					deviceId: Number(device.id),
					order: null,
					description: device.description ?? "",
				},
			}));

			if (linkValidationProjectDevice.fulfilled.match(result)) {
				onSuccess(unwrapResult(result));
				return;
			}

			let errorMsg = "error";
			if (result.payload && result.payload.kind === "http" && result.payload.problem) {
				errorMsg = result.payload.problem.title;
			}
			dispatch(showError(errorMsg));
		} catch (err) {
			const apiError = err as APIError | Error;
			dispatch(showError(apiError instanceof Error ? apiError.message : "error"));
		}
	};

	return <CreateDeviceDialog onSuccess={handleDeviceCreated} onCancel={onCancel} />;
};